<template>
  <div class="text-md-left">

    <el-button type="primary" @click="addCourier">เพิ่มขนส่ง</el-button>
    <dialog-courier-add :data.sync="dialogCourierLimit" @addCourier="handleAddCourierAccount"/>
    <el-table
      :data="data.shopDetail.courierLimitDay"
      :header-cell-style="{'background-color': 'black', 'color': 'white', 'text-align': 'center'}"
      style="width: 100%;padding-top:10px">
      <el-table-column
        label="ขนส่ง"
        width="120">
        <div class="text-md-left" slot-scope="scope">
          {{getCourier(scope.row.courierId)}}
        </div>
      </el-table-column>
      <el-table-column
        label="จำนวนชิ้น / วัน"
        width="120">
        <div class="text-md-left" slot-scope="scope">
          <!-- {{ scope.row.apiData.status ? scope.row.apiData.password : '-' }} -->
          <el-input
            v-model.number="scope.row.limit"
            type="number"
          ></el-input>
        </div>
      </el-table-column>
      <el-table-column
        label="จัดการ"
        width="200"
      >
        <div slot-scope="scope">
          <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            @click="handleDeleteCourierAccount(scope.$index)"
          ></el-button>
          <el-button
            type="info"
            :disabled="scope.$index===0"
            size="small"
            icon="el-icon-arrow-up"
            @click="handleUpCourierAccount(scope.$index)"
          ></el-button>
          <el-button
            type="info"
            :disabled="scope.$index === (data.shopDetail.courierLimitDay.length -1)"
            size="small"
            icon="el-icon-arrow-down"
            @click="handleDownCourierAccount(scope.$index)"
          ></el-button>
        </div>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
// import fgApi from '@/services/fillgoods'
import dialogCourierAdd from '@/components/Shop/DialogShop/DialogAddCourierLimit'
export default {
    name: 'courierLimit',
    props: {
        data: {
            type: Object,
            default: null
        }
    },
    components: {
        dialogCourierAdd
    },
    data () {
        return {
            dialogCourierLimit: {
                dialog: false,
                userId: null
            }
        }
    },
    watch: {
        // 'data.dialogVisible' (val) {}
    },
    created () {},
    methods: {
        handleDeleteCourierAccount (obj) {
            this.$confirm('ยืนยันการลบรายการ ?', 'แจ้งเตือน!', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: 'ลบสำเร็จ'
                })
                this.data.shopDetail.courierLimitDay.splice(obj, 1)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'ยกเลิกการลบ'
                })
            })
        },
        handleUpCourierAccount (index) {
            let temp = { ...this.data.shopDetail.courierLimitDay[index] }
            this.$set(this.data.shopDetail.courierLimitDay, index, { ...this.data.shopDetail.courierLimitDay[index - 1] })
            this.$set(this.data.shopDetail.courierLimitDay, index - 1, temp)
        },
        handleDownCourierAccount (index) {
            let temp = { ...this.data.shopDetail.courierLimitDay[index] }
            this.$set(this.data.shopDetail.courierLimitDay, index, { ...this.data.shopDetail.courierLimitDay[index + 1] })
            this.$set(this.data.shopDetail.courierLimitDay, index + 1, temp)
        },
        addCourier () {
            this.dialogCourierLimit.dialog = !this.dialogCourierLimit.dialog
            this.dialogCourierLimit.userId = this.data.shopDetail.userId
            console.log(this.dialogCourierLimit)
        },
        handleAddCourierAccount (val) {
            this.dialogCourierLimit.dialog = !this.dialogCourierLimit.dialog
            if (val === 2) {
                this.innerVisible = false
                this.$message({
                    type: 'info',
                    message: 'Kerry ไม่สามารถกำหนดข้อมูลจำกัดจำนวนออเดอร์ของขนส่ง'
                })
                return
            }
            if (this.data.shopDetail.courierLimitDay) {
                let check = this.data.shopDetail.courierLimitDay.filter((e) => e.courierId === val)
                if (check.length > 0) {
                    this.innerVisible = false
                    this.$message({
                        type: 'info',
                        message: 'ข้อมูลซ้ำ'
                    })
                } else {
                    let data = {
                        courierId: val,
                        limit: 0
                    }
                    this.data.shopDetail.courierLimitDay.push(data)
                    this.innerVisible = false
                }
            } else {
                this.data.shopDetail.courierLimitDay = [
                    { courierId: val,
                        limit: 0 }
                ]
                this.innerVisible = false
            }
        }
    }
}
</script>
